import { render } from "./GuardingOurGuardContent.vue?vue&type=template&id=5f726316"
import script from "./GuardingOurGuardContent.vue?vue&type=script&lang=js"
export * from "./GuardingOurGuardContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__